module.exports = __webpack_public_path__ + "static/media/20-active.1799bd34.png";